@if (permisos().r || permisosPDA().r) {
    <div id="sied" class="page-layout simple fullwidth">
        @if (isEvaluator() === false) {
            <div fxLayout="row wrap" class="p-24">
                <h1>No tienes permisos para ver el dashboard de este usuario.</h1>
            </div>
        }

        @if (isEvaluator()) {
            <div fxLayout="row wrap" class="p-24">
                @if (permisos().r && urlEntrada === "sied") {
                    <div fxLayout="column" fxFlex="40" class="user-container px-16">
                        <div class="fuse-card card-border-top card-sied card-sied-actual p-16 py-28" [@onRenderUp]>
                            <mat-icon class="btn-help" (click)="openDialogInfo('sied-actual')">help</mat-icon>
                            <div fxLayout="row" class="resumen">
                                @if (person()) {
                                    <div fxFlex="40" fxLayout="column" fxLayoutAlign="center center" class="px-12">
                                        <div class="person-avatar" fxLayout="row" fxLayoutAlign="center flex-start">
                                            <img
                                                class="img-circle"
                                                [src]="getImagePerson(person()!.username)"
                                                [alt]="person()!.displayName"
                                            />
                                        </div>
                                        <h5 class="m-0 my-8 name-user">{{ person()!.displayName }}</h5>
                                        @if (mainPeriod()) {
                                            <div class="w-100-p">
                                                @if (!mainPeriod()!.isLast && !mainPeriod()!.isActive) {
                                                    <button
                                                        [disabled]="!evalForm?.autoevaluation && isSelfPage"
                                                        mat-raised-button
                                                        class="btn-feedbalia w-100-p"
                                                        (click)="openEvaluation('main')"
                                                    >
                                                        {{ "person_card.sied.auto" | translate }}
                                                    </button>
                                                }
                                                @if (mainPeriod()!.isActive) {
                                                    <button
                                                        [disabled]="!evalForm?.autoevaluation && isSelfPage"
                                                        mat-raised-button
                                                        class="btn-feedbalia w-100-p"
                                                        (click)="openEvaluation('main')"
                                                    >
                                                        {{ "person_card.sied.auto" | translate }}
                                                    </button>
                                                }
                                                @if (mainPeriod()!.isLast) {
                                                    <button
                                                        mat-raised-button
                                                        class="btn-feedbalia w-100-p"
                                                        (click)="openEvaluation('last')"
                                                    >
                                                        {{ "person_card.sied.showScore" | translate }}
                                                    </button>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                @if (mainPeriod()) {
                                    <div fxFlex="60" fxLayout="column" class="datos-sied-actual px-16">
                                        <div fxLayout="column">
                                            <h5 class="text-theme m-0 mb-4">{{ mainPeriod()!.name }}</h5>
                                            <div fxLayout="row" fxLayoutAlign="flex-start center">
                                                <mat-icon class="icon-calendar">calendar_today</mat-icon>
                                                @if (mainPeriod()!.isActive) {
                                                    <h6 class="m-0 pl-4 font-size-12">
                                                        {{ "evaluation.time.to" | translate }}
                                                        {{ formatDate(mainPeriod()!.endPeriod) }}
                                                    </h6>
                                                }
                                                @if (mainPeriod()!.isLast) {
                                                    <h6 class="m-0 pl-4 font-size-12">
                                                        {{ "evaluation.finishedPeriod" | translate }}
                                                    </h6>
                                                }
                                                @if (!mainPeriod()!.isLast && !mainPeriod()!.isActive) {
                                                    <h6 class="m-0 pl-4 font-size-12">
                                                        Disponible del {{ formatDate(mainPeriod()!.startPeriod) }} al
                                                        {{ formatDate(mainPeriod()!.endPeriod) }}
                                                    </h6>
                                                }
                                            </div>
                                        </div>
                                        <div
                                            fxFlex="1 1 0"
                                            fxLayout="row"
                                            fxLayoutAlign="space-between flex-end"
                                            class="px-8"
                                        >
                                            <div fxLayout="column" fxLayoutAlign="center center">
                                                <h3 class="m-0 font-size-22 text-theme">{{ currentScore }}</h3>
                                                <h6 class="m-0 font-size-8">
                                                    {{ "evaluation.sied.currentScore" | translate }}
                                                </h6>
                                            </div>
                                            @if (avgScore) {
                                                <div fxLayout="column" fxLayoutAlign="center center">
                                                    <h3 class="m-0 font-size-22 text-theme">{{ avgScore }}</h3>
                                                    <h6 class="m-0 font-size-8">
                                                        {{ "evaluation.sied.avgScore" | translate }}
                                                    </h6>
                                                </div>
                                            }
                                            @if (actionPlansCount() > 0) {
                                                <div fxLayout="column" fxLayoutAlign="center center">
                                                    <h3 class="m-0 font-size-22 text-theme">
                                                        {{ actionPlansCount() }}
                                                    </h3>
                                                    <h6 class="m-0 font-size-8">
                                                        {{ "evaluation.sied.total.actions" | translate }}
                                                    </h6>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                                @if (mainPeriod() == null) {
                                    <div fxFlex="60" fxLayout="column" class="datos-sied-actual px-16">
                                        <div fxLayout="row" fxLayoutAlign="flex-start center">
                                            <mat-icon class="icon-calendar">calendar_today</mat-icon>
                                            <h6 class="m-0 pl-4 font-size-12">
                                                {{ "evaluation.noPeriod" | translate }}
                                            </h6>
                                        </div>
                                    </div>
                                }
                            </div>
                            <!-- Periodo de revisión -->
                            @if (evaluationPanel?.showPanelEvaluations && paRevisionPeriod && isSelfPage) {
                                <div class="evaluation-question-container mt-24 p-12" style="background: #f9000045">
                                    <h3 class="text-center text-danger" style="font-size: 16px">
                                        Periodo de revisión de planes de acción activo. Reúnete con tus colaboradores
                                        para llevar a cabo la revisión.
                                    </h3>
                                    @if (evaluation) {
                                        <div fxLayout="row wrap" fxLayoutAlign="center center">
                                            <button
                                                class="action-button btn-danger pointer mr-16"
                                                (click)="openPanelControl(2)"
                                            >
                                                Revisar ahora
                                            </button>
                                        </div>
                                    }
                                </div>
                            }
                            <!-- Control panel -->
                            @if (project()?.name === "leroymerlin") {
                                @if (evaluationPanel?.showPanelEvaluations && isSelfPage) {
                                    <div fxLayout="row" class="evaluation-panel mt-24">
                                        <div fxFlex="33" class="p-16 pendings" (click)="openPanelControl(0)">
                                            <h1 class="m-0">{{ evaluationPanel.totalPendings }}</h1>
                                            <p class="m-0">{{ "evaluation.pendings" | translate }}</p>
                                        </div>
                                        <div fxFlex="33" class="p-16 sended" (click)="openPanelControl(1)">
                                            <h1 class="m-0">{{ evaluationPanel.totalDone }}</h1>
                                            <p class="m-0">{{ "evaluation.sendings" | translate }}</p>
                                        </div>
                                        <div fxFlex="33" class="p-16 totals" (click)="openPanelControl(2)">
                                            <h1 class="m-0">{{ evaluationPanel.totalEvaluations }}</h1>
                                            <p class="m-0">{{ "evaluation.totals" | translate }}</p>
                                        </div>
                                    </div>
                                }
                                @if (
                                    isSelfPage &&
                                    showTeamButton &&
                                    project()?.name === "leroymerlin" &&
                                    !mainPeriod()?.isActive
                                ) {
                                    <div fxLayout="row" class="evaluation-panel mt-24">
                                        <button
                                            mat-raised-button
                                            class="btn-feedbalia w-100-p"
                                            (click)="goToColaboradoresActuales()"
                                        >
                                            Puntuaciones última EDT de mi equipo
                                        </button>
                                        <mat-icon class="btn-help ml-8" (click)="openDialogInfo('sied-futuro')"
                                            >help</mat-icon
                                        >
                                    </div>
                                }
                            }
                            @if (project()?.name !== "leroymerlin") {
                                @if (evaluationPanel?.showPanelEvaluations && isSelfPage) {
                                    <div fxLayout="row" class="evaluation-panel mt-24">
                                        <div fxFlex="33" class="p-16 pendings" (click)="openPanelControl(0)">
                                            <h1 class="m-0">{{ evaluationPanel.totalPendings }}</h1>
                                            <p class="m-0">{{ "evaluation.pendings" | translate }}</p>
                                        </div>
                                        <div fxFlex="33" class="p-16 sended" (click)="openPanelControl(1)">
                                            <h1 class="m-0">{{ evaluationPanel.totalDone }}</h1>
                                            <p class="m-0">{{ "evaluation.sendings" | translate }}</p>
                                        </div>
                                        <div fxFlex="33" class="p-16 totals" (click)="openPanelControl(2)">
                                            <h1 class="m-0">{{ evaluationPanel.totalEvaluations }}</h1>
                                            <p class="m-0">{{ "evaluation.totals" | translate }}</p>
                                        </div>
                                    </div>
                                }
                                @if (evaluationPanel?.showPanelEvaluations && project()?.name === "syrsa") {
                                    <div fxLayout="row" class="evaluation-panel mt-24">
                                        <button
                                            mat-raised-button
                                            class="btn-feedbalia w-100-p"
                                            (click)="goToColaboradoresActuales()"
                                        >
                                            Puntuaciones de mi equipo en periodos anterirores
                                        </button>
                                    </div>
                                }
                            }
                        </div>
                        <!-- Cuestionario manager -->
                        @if (
                            user()!.id === person()!.id &&
                            mainPeriod()?.isActive &&
                            mainPeriod()?.isEnabledEvaluationEvaluators &&
                            evaluatorsToEvaluate
                        ) {
                            <div [@onRenderUp] class="fuse-card card-border-top card-sied">
                                <h4 class="text-center text-theme m-8" style="font-weight: bold; font-size: 14px">
                                    Cuestionario de evaluación al manager
                                </h4>
                                @for (evaluator of evaluatorsToEvaluate; track evaluator) {
                                    <div
                                        fxLayout="row wrap"
                                        fxLayoutAlign="space-between center"
                                        class="evaluation-evaluators-container m-24 p-24"
                                    >
                                        <div fxLayout="row wrap" fxLayoutAlign="center center">
                                            <div class="person-avatar-xs mr-16">
                                                <img
                                                    class="img-circle"
                                                    [src]="getImagePerson(evaluator.nickname)"
                                                    [alt]="evaluator.displayName"
                                                    [title]="evaluator.displayName"
                                                />
                                            </div>
                                            <span style="font-weight: bold">{{ evaluator.displayName }}</span>
                                        </div>
                                        <button
                                            class="action-button pointer"
                                            (click)="goToManagerEvaluation(evaluator)"
                                        >
                                            Evaluar ahora
                                        </button>
                                    </div>
                                }
                            </div>
                        }
                        <!-- Reunión manager -->
                        @if (
                            user()!.id === person()!.id &&
                            mainPeriod()?.isActive &&
                            mainPeriod()?.isEnabledCheckQuestion &&
                            evaluation
                        ) {
                            <div [@onRenderUp] class="evaluation-question-container mb-12 p-24">
                                <h3 class="text-center" style="font-size: 16px">
                                    ¿Has tenido la entrevista de talento con tu manager para hablar de los resultados de
                                    la evaluación?
                                </h3>
                                @if (evaluation) {
                                    <div fxLayout="row wrap" fxLayoutAlign="center center">
                                        <button
                                            class="action-button pointer mr-16"
                                            [ngClass]="evaluation.checkByUser ? 'enabled' : 'disabled'"
                                            (click)="setCheckByUser(true)"
                                        >
                                            Sí
                                        </button>
                                        <button
                                            class="action-button pointer"
                                            [ngClass]="!evaluation.checkByUser ? 'enabled' : 'disabled'"
                                            (click)="setCheckByUser(false)"
                                        >
                                            No
                                        </button>
                                    </div>
                                }
                            </div>
                        }
                        <!-- Feedback privado -->
                        @if (
                            (privateFeedbackRequestList || privateFeedbackResponseList || privateFeedbackHistory) &&
                            user()!.id === person()!.id
                        ) {
                            <div [@onRenderUp] class="fuse-card card-border-top card-sied card-historico">
                                <mat-tab-group mat-align-tabs="center">
                                    <!-- Solicitados -->
                                    @if (privateFeedbackRequestList) {
                                        <mat-tab class="text-theme" label="Feedback privado solicitado">
                                            <div class="p-8" fxLayout="row wrap" fxLayoutAlign="center center">
                                                @for (itemFeed of privateFeedbackRequestList; track itemFeed) {
                                                    <div
                                                        class="card-private-feedback p-8 m-8"
                                                        fxLayout="column"
                                                        fxLayoutAlign="center center"
                                                    >
                                                        <div class="person-avatar">
                                                            <img
                                                                class="img-circle"
                                                                [src]="getImagePerson(itemFeed.personAboutNickname)"
                                                                [alt]="itemFeed.personAboutName"
                                                                [title]="itemFeed.personAboutName"
                                                            />
                                                        </div>
                                                        <p class="m-0 font-size-12 text-center">
                                                            Sobre: {{ itemFeed.personAboutName }}
                                                        </p>
                                                        <mat-icon>arrow_upward</mat-icon>
                                                        <div class="person-avatar-xs">
                                                            <img
                                                                class="img-circle"
                                                                [src]="getImagePerson(itemFeed.personResponseNickname)"
                                                                [alt]="itemFeed.personResponseName"
                                                                [title]="itemFeed.personResponseName"
                                                            />
                                                        </div>
                                                        <p class="m-0 font-size-10 text-center">
                                                            Para: {{ itemFeed.personResponseName }}
                                                        </p>
                                                        @if (!itemFeed.response) {
                                                            <p class="m-0 font-size-14 blue-font">
                                                                <strong>Pendiente</strong>
                                                            </p>
                                                        }
                                                        @if (itemFeed.response) {
                                                            <p
                                                                class="m-0 font-size-14 pointer"
                                                                style="color: green"
                                                                (click)="
                                                                    openFeedbackDialog(
                                                                        mainPeriod()!.name,
                                                                        itemFeed,
                                                                        false
                                                                    )
                                                                "
                                                            >
                                                                <strong>Ver respuesta</strong>
                                                            </p>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </mat-tab>
                                    }
                                    <!-- Peticiones -->
                                    @if (privateFeedbackResponseList) {
                                        <mat-tab class="text-theme" label="Peticiones feedback privado">
                                            <div class="p-8" fxLayout="row wrap" fxLayoutAlign="center center">
                                                @for (itemFeed of privateFeedbackResponseList; track itemFeed) {
                                                    <div
                                                        class="card-private-feedback p-8 m-8"
                                                        fxLayout="column"
                                                        fxLayoutAlign="center center"
                                                    >
                                                        <div class="person-avatar">
                                                            <img
                                                                class="img-circle"
                                                                [src]="getImagePerson(itemFeed.personAboutNickname)"
                                                                [alt]="itemFeed.personAboutName"
                                                                [title]="itemFeed.personAboutName"
                                                            />
                                                        </div>
                                                        <p class="m-0 font-size-12 text-center">
                                                            Sobre: {{ itemFeed.personAboutName }}
                                                        </p>
                                                        <mat-icon>arrow_upward</mat-icon>
                                                        <div class="person-avatar-xs">
                                                            <img
                                                                class="img-circle"
                                                                [src]="getImagePerson(itemFeed.personRequestNickname)"
                                                                [alt]="itemFeed.personRequestName"
                                                                [title]="itemFeed.personRequestName"
                                                            />
                                                        </div>
                                                        <p class="m-0 font-size-10 text-center">
                                                            De: {{ itemFeed.personRequestName }}
                                                        </p>
                                                        @if (!itemFeed.response) {
                                                            <p
                                                                class="m-0 font-size-14 blue-font pointer"
                                                                (click)="openFeedbackDialog(null, itemFeed, true)"
                                                            >
                                                                <strong>Responder</strong>
                                                            </p>
                                                        }
                                                        @if (itemFeed.response) {
                                                            <p
                                                                class="m-0 font-size-14 pointer"
                                                                style="color: green"
                                                                (click)="
                                                                    openFeedbackDialog(
                                                                        mainPeriod()!.name,
                                                                        itemFeed,
                                                                        false
                                                                    )
                                                                "
                                                            >
                                                                <strong>Ver respuesta</strong>
                                                            </p>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </mat-tab>
                                    }
                                    <!-- Historico -->
                                    @if (privateFeedbackHistory) {
                                        <mat-tab class="text-theme" label="Histórico feedback privado">
                                            <div class="p-8">
                                                @for (itemPeriod of privateFeedbackHistory; track itemPeriod) {
                                                    <div fxLayout="column">
                                                        <div
                                                            class="pointer"
                                                            fxLayout="row"
                                                            fxLayoutAlign="space-between center"
                                                            (click)="tooglePeriod(itemPeriod)"
                                                        >
                                                            <h5 class="m-8 font-size-16 blue-font">
                                                                <strong>{{ itemPeriod.name }}</strong>
                                                            </h5>
                                                            <mat-icon class="s-18">{{
                                                                !itemPeriod.extended
                                                                    ? "keyboard_arrow_down"
                                                                    : "keyboard_arrow_up"
                                                            }}</mat-icon>
                                                        </div>
                                                        @for (itemFeed of itemPeriod.feedbackRequest; track itemFeed) {
                                                            <div>
                                                                @if (itemPeriod.extended) {
                                                                    <div
                                                                        fxLayout="column"
                                                                        class="p-8 mb-8 feedback-history"
                                                                    >
                                                                        <strong class="m-0 font-size-14">{{
                                                                            formatDateString(itemFeed.creationDate)
                                                                        }}</strong>
                                                                        <div fxLayout="row" fxLayoutAlign="left center">
                                                                            <div fxFlex="30" fxLayout="column">
                                                                                <h5 class="m-0 font-size-14">
                                                                                    Solicitud de
                                                                                </h5>
                                                                                <h5 class="m-0 font-size-12 blue-font">
                                                                                    {{ user()!.displayName }}
                                                                                </h5>
                                                                            </div>
                                                                            <div fxFlex="30" fxLayout="column">
                                                                                <h5 class="m-0 font-size-14">Para</h5>
                                                                                <h5 class="m-0 font-size-12 blue-font">
                                                                                    {{ itemFeed.personResponseName }}
                                                                                </h5>
                                                                            </div>
                                                                            <div fxFlex="30" fxLayout="column">
                                                                                <h5 class="m-0 font-size-14">Sobre</h5>
                                                                                <h5 class="m-0 font-size-12 blue-font">
                                                                                    {{ itemFeed.personAboutName }}
                                                                                </h5>
                                                                            </div>
                                                                            <div fxFlex="10" class="px-8 pointer">
                                                                                <mat-icon
                                                                                    (click)="
                                                                                        openFeedbackDialog(
                                                                                            itemPeriod.name,
                                                                                            itemFeed,
                                                                                            false
                                                                                        )
                                                                                    "
                                                                                    >visibility</mat-icon
                                                                                >
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </mat-tab>
                                    }
                                </mat-tab-group>
                            </div>
                        }
                        <!-- Historicos -->
                        <div class="fuse-card card-border-top card-sied card-historico" [@onRenderUp]>
                            <mat-tab-group mat-align-tabs="center" (selectedTabChange)="historyTabChanged($event)">
                                <!-- Evaluaciones -->
                                <mat-tab class="text-theme" label="{{ 'evaluation.sied.historico' | translate }}">
                                    <mat-icon class="btn-help" (click)="openDialogInfo('historico')">help</mat-icon>
                                    @if (history) {
                                        <div>
                                            <div class="listado p-8">
                                                @for (itemEval of history; track itemEval) {
                                                    <div
                                                        class="evaluacion p-8 mb-8"
                                                        fxLayout="row"
                                                        [ngClass]="project()?.id == 472 ? 'sinFondo' : ''"
                                                    >
                                                        <div fxFlex="20" class="px-8">
                                                            @if (itemEval.es_cualitativa == 0) {
                                                                <h5 class="m-0 font-size-14">
                                                                    <b>{{ itemEval.totalResult.toFixed(2) }}</b>
                                                                </h5>
                                                            }
                                                            @if (itemEval.es_cualitativa == 1) {
                                                                <h5 class="m-0 font-size-12">
                                                                    <b>Evalución cualitativa</b>
                                                                </h5>
                                                            }
                                                        </div>
                                                        <div fxFlex="70" fxLayout="column" class="px-8">
                                                            <h5 class="m-0 font-size-14">{{ itemEval.periodName }}</h5>
                                                            <h6 class="m-0 font-size-10">{{ itemEval.puestoName }}</h6>
                                                        </div>
                                                        <div fxFlex="30" class="px-8">
                                                            <h6 class="m-0 pointer">
                                                                <a
                                                                    class="text-muted"
                                                                    (click)="goToEvaluationForm(itemEval)"
                                                                    >{{ "evaluation.btn.see" | translate }}</a
                                                                >
                                                            </h6>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                    @if (!history) {
                                        <div>
                                            <div class="listado p-8">
                                                {{ "evaluation.no.elements" | translate }}
                                            </div>
                                        </div>
                                    }
                                </mat-tab>
                                <!-- Cuestionarios -->
                                @if (mainPeriod()?.isEnabledEvaluationEvaluators) {
                                    <mat-tab class="text-theme" label="Histórico de cuestionarios">
                                        @if (history) {
                                            <div>
                                                <div class="listado p-8">
                                                    @for (itemEval of history; track itemEval) {
                                                        <div class="evaluacion p-8 mb-8" fxLayout="row">
                                                            <div fxFlex="20" class="px-8"></div>
                                                            <div fxFlex="70" fxLayout="column" class="px-8">
                                                                <h5 class="m-0 font-size-14">
                                                                    {{ itemEval.periodName }}
                                                                </h5>
                                                                <h6 class="m-0 font-size-10">
                                                                    {{ itemEval.puestoName }}
                                                                </h6>
                                                            </div>
                                                            <div fxFlex="30" class="px-8">
                                                                <h6 class="m-0 pointer">
                                                                    <a
                                                                        class="text-muted"
                                                                        (click)="goToEvaluationForm(itemEval)"
                                                                        >{{
                                                                            "person_card.sied.showScore" | translate
                                                                        }}</a
                                                                    >
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        @if (!history) {
                                            <div>
                                                <div class="listado p-8">
                                                    {{ "evaluation.no.elements" | translate }}
                                                </div>
                                            </div>
                                        }
                                    </mat-tab>
                                }
                            </mat-tab-group>
                        </div>
                    </div>
                }
                <div fxLayout="column" fxFlex="60" class="evaluation-container px-16" [@onRenderUp]>
                    @if (permisosPDA().r && proyectoCargado()) {
                        <div
                            fxLayout="column"
                            class="fuse-card card-border-top card-sied card-planes-accion p-24 gap-1"
                        >
                            @if (urlEntrada === "sied") {
                                <mat-icon class="btn-help" (click)="openDialogInfo('plan-accion')">help</mat-icon>
                            }
                            @if (urlEntrada === "objetivos") {
                                @if (objetivosRevision() && !isSelfPage) {
                                    <div class="w-100-p contenedor" fxLayout="row" fxLayoutAlign="end end">
                                        <div
                                            fxLayout="column"
                                            class="w-100-p"
                                            fxFlex="2 1 0"
                                            fxLayoutAlign="center center"
                                        >
                                            @if (!nextSelected) {
                                                <b style="font-size: 24px; color: var(--feedbalia-color-primary-500)"
                                                    >{{ "evaluation.objetivos.actuales" | translate }} -
                                                    {{ person()!.displayName }}</b
                                                >
                                            }
                                            @if (nextSelected) {
                                                <b style="font-size: 24px; color: var(--feedbalia-color-primary-500)"
                                                    >{{ "evaluation.objetivos.proximos" | translate }} -
                                                    {{ person()!.displayName }}</b
                                                >
                                            }
                                        </div>
                                    </div>
                                    <div class="w-100-p contenedor" fxLayout="row" fxLayoutAlign="end end">
                                        <div
                                            fxLayout="column"
                                            class="w-100-p"
                                            fxFlex="3 1 0"
                                            fxLayoutAlign="start end"
                                            style="padding: 5px"
                                        >
                                            <button
                                                mat-raised-button
                                                color="primary"
                                                [disabled]="!nextSelected"
                                                (click)="setNextSelected(false)"
                                            >
                                                {{ "evaluation.objetivos.verActuales" | translate }}
                                            </button>
                                        </div>
                                        <div
                                            fxLayout="column"
                                            class="w-100-p"
                                            fxFlex="3 1 0"
                                            fxLayoutAlign="start start"
                                            style="padding: 5px"
                                        >
                                            <button
                                                mat-raised-button
                                                color="primary"
                                                [disabled]="nextSelected"
                                                (click)="setNextSelected(true)"
                                            >
                                                {{ "evaluation.objetivos.verProximos" | translate }}
                                            </button>
                                        </div>
                                    </div>
                                }
                                @if (nextSelected) {
                                    <div fxLayout="row">
                                        <div fxFlex="60" fxLayout="column">
                                            <h5 class="m-0 font-size-14 text-theme">
                                                {{ "evaluation.objetivos.proximos" | translate }}
                                            </h5>
                                            <h6 class="m-0 font-size-12">
                                                {{ "evaluation.objetivos.proximosColborador" | translate }}
                                            </h6>
                                        </div>
                                        <div fxFlex="40" fxLayout="row" fxLayoutAlign="space-around center"></div>
                                    </div>
                                    <div fxLayout="column" class="gap-1">
                                        @if (permisosPDA().w && project()?.tandemMode != 1) {
                                            @if (urlEntrada === "sied" || objetivosRevision) {
                                                @if (nextPDA().length < 10) {
                                                    @if (project()?.id != 10) {
                                                        <div fxLayout="row" fxLayoutAlign="center center" class="gap-1">
                                                            <mat-form-field
                                                                subscriptSizing="dynamic"
                                                                appearance="outline"
                                                                class="w-100-p"
                                                            >
                                                                <mat-label>{{
                                                                    "evaluation.actionplan.placeholder.add.title"
                                                                        | translate
                                                                }}</mat-label>
                                                                <input
                                                                    matInput
                                                                    class="gap-1"
                                                                    (focus)="showHelpBoxActionPlan = true"
                                                                    (blur)="showHelpBoxActionPlan = false"
                                                                    (change)="onActionPlanTitle($event)"
                                                                />
                                                            </mat-form-field>
                                                            <button
                                                                mat-raised-button
                                                                class="btn-feedbalia"
                                                                [disabled]="!canCreatePlanAction()"
                                                                (click)="addPABlue()"
                                                            >
                                                                <mat-icon>add_circle</mat-icon>
                                                                {{ "evaluation.actionplan.next.add" | translate }}
                                                            </button>
                                                        </div>
                                                    }
                                                } @else {
                                                    @if (project()?.id != 10) {
                                                        <div fxLayout="row" fxLayoutAlign="center center" class="gap-1">
                                                            <span style="font-style: italic">{{
                                                                "evaluation.objetivos.max" | translate
                                                            }}</span>
                                                        </div>
                                                    }
                                                }
                                            }
                                        }
                                        @if (showHelpBoxActionPlan) {
                                            <div fxLayout="row" class="alert alert-info">
                                                <span>{{ "evaluation.objetivos.definicion" | translate }}</span>
                                            </div>
                                        }
                                    </div>
                                    @if (checkNextPesos()) {
                                        <div fxLayout="row">
                                            <b>{{ "evaluation.objetivos.recuerde" | translate }}</b>
                                        </div>
                                    } @else {
                                        <div fxLayout="row">
                                            <b style="color: brown"
                                                >{{ "evaluation.objetivos.recuerdeActual" | translate }}
                                                {{ sumaDePesos }}%</b
                                            >
                                        </div>
                                    }
                                } @else {
                                    <div fxLayout="row">
                                        <div fxFlex="60" fxLayout="column">
                                            <b style="font-size: 24px; color: var(--feedbalia-color-primary-500)"
                                                >{{ "evaluation.objetivos" | translate | uppercase }}
                                                {{ objEvaluandose }}</b
                                            >
                                            <h6 class="m-0 font-size-14">
                                                {{ "evaluation.objetivos.before" | translate }}
                                            </h6>
                                        </div>
                                        <div fxFlex="40" fxLayout="row" fxLayoutAlign="space-around center">
                                            @if (urlEntrada === "sied") {
                                                <div fxLayout="column" class="text-center gap-1">
                                                    <div class="accionPend gap-1">
                                                        <mat-icon>access_time</mat-icon>
                                                        <span class="font-size-18">{{ totalActionPending() }}</span>
                                                    </div>
                                                    <h6 class="m-0 text-theme font-size-8">
                                                        {{ "evaluation.value.pending" | translate | uppercase }}
                                                    </h6>
                                                </div>
                                                <div fxLayout="column" class="text-center gap-1">
                                                    <div class="accionComp gap-1">
                                                        <mat-icon>check_box</mat-icon>
                                                        <span class="font-size-18">{{ totalActionDone() }}</span>
                                                    </div>
                                                    <h6 class="m-0 text-theme font-size-8">
                                                        {{ "evaluation.value.completed" | translate | uppercase }}
                                                    </h6>
                                                </div>
                                            }
                                            @if (
                                                !isSelfPage &&
                                                !nextSelected &&
                                                urlEntrada === "objetivos" &&
                                                project()?.id == 94
                                            ) {
                                                <div fxLayout="row" fxLayoutAlign="end end">
                                                    <div
                                                        fxLayout="column"
                                                        fxLayoutAlign="center center"
                                                        class="total-ponderado-box p-8"
                                                    >
                                                        <div fxLayout="row" fxLayoutAlign="center center">
                                                            <b>{{ "objetivos.totalponderado" | translate }}</b>
                                                        </div>
                                                        <div
                                                            fxLayout="row"
                                                            fxLayoutAlign="center center"
                                                            style="font-size: 24px"
                                                        >
                                                            <span
                                                                [ngStyle]="{
                                                                    color: calculateBackgroundColor(
                                                                        getPonderacionesObjetivos()
                                                                    )
                                                                }"
                                                                ><b>{{ getPonderacionesObjetivos() }} %</b></span
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            } @else {
                                <div fxLayout="row">
                                    <div fxFlex="60" fxLayout="column">
                                        <h5 class="m-0 font-size-14 text-theme">
                                            {{ "evaluation.actionplan" | translate | uppercase }}
                                        </h5>
                                        <h6 class="m-0 font-size-12">{{ "evaluation.complete.before" | translate }}</h6>
                                    </div>
                                    <div fxFlex="40" fxLayout="row" fxLayoutAlign="space-around center">
                                        <div fxLayout="column" class="text-center gap-1">
                                            <div class="accionPend gap-1">
                                                <mat-icon>access_time</mat-icon>
                                                <span class="font-size-18">{{ totalActionPending() }}</span>
                                            </div>
                                            <h6 class="m-0 text-theme font-size-8">
                                                {{ "evaluation.value.pending" | translate | uppercase }}
                                            </h6>
                                        </div>
                                        <div fxLayout="column" class="text-center gap-1">
                                            <div class="accionComp gap-1">
                                                <mat-icon>check_box</mat-icon>
                                                <span class="font-size-18">{{ totalActionDone() }}</span>
                                            </div>
                                            <h6 class="m-0 text-theme font-size-8">
                                                {{ "evaluation.value.completed" | translate | uppercase }}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                @if (project()?.name !== "syrsa") {
                                    <div fxLayout="column" class="gap-1">
                                        @if (permisosPDA().w && project()?.tandemMode != 1) {
                                            @if (urlEntrada === "sied" || objetivosRevision) {
                                                @if (project()?.id != 10) {
                                                    <div fxLayout="row" fxLayoutAlign="center center" class="gap-1">
                                                        <mat-form-field
                                                            subscriptSizing="dynamic"
                                                            appearance="outline"
                                                            class="w-100-p"
                                                        >
                                                            <mat-label>{{
                                                                "evaluation.actionplan.placeholder.add.title"
                                                                    | translate
                                                            }}</mat-label>
                                                            <input
                                                                matInput
                                                                class="gap-1"
                                                                (focus)="showHelpBoxActionPlan = true"
                                                                (blur)="showHelpBoxActionPlan = false"
                                                                (change)="onActionPlanTitle($event)"
                                                            />
                                                        </mat-form-field>
                                                        <button
                                                            mat-raised-button
                                                            class="btn-feedbalia"
                                                            [disabled]="!canCreatePlanAction()"
                                                            (click)="addPA()"
                                                        >
                                                            <mat-icon>add_circle</mat-icon>
                                                            {{ "evaluation.actionplan.next.add" | translate }}
                                                        </button>
                                                    </div>
                                                }
                                            }
                                        }
                                        @if (showHelpBoxActionPlan) {
                                            <div fxLayout="row" class="alert alert-info">
                                                <span>{{ "evaluation.actionplan.help" | translate }}</span>
                                            </div>
                                        }
                                    </div>
                                    @if (urlEntrada === "sied") {
                                        <mat-divider />
                                        <form fxLayout="row" name="form" [formGroup]="formFiltroPlanAccion">
                                            <mat-form-field
                                                subscriptSizing="dynamic"
                                                appearance="outline"
                                                class="w-100-p"
                                            >
                                                <mat-label>{{
                                                    "evaluation.actionplan.placeholder.search.title" | translate
                                                }}</mat-label>
                                                <input matInput #titleFilter (keyup)="filterPATitle(titleFilter)" />
                                            </mat-form-field>
                                        </form>
                                        <div class="gap-1" fxLayout="row">
                                            <mat-form-field
                                                subscriptSizing="dynamic"
                                                appearance="outline"
                                                class="w-100-p"
                                            >
                                                <mat-label>{{
                                                    "evaluation.actionplan.filter.status" | translate
                                                }}</mat-label>
                                                @if (project()?.tandemMode == 1) {
                                                    <mat-select [(ngModel)]="filterPAForm.status">
                                                        <mat-option class="select-green" [value]="'100'">
                                                            <b style="color: #ffffff; font-size: 16px">{{
                                                                "evaluation.actionplan.filter.completed" | translate
                                                            }}</b></mat-option
                                                        >
                                                        <mat-option class="select-yellow" [value]="'50'">
                                                            <b style="color: #ffffff; font-size: 16px">{{
                                                                "evaluation.actionplan.filter.progress" | translate
                                                            }}</b></mat-option
                                                        >
                                                        <mat-option class="select-red" [value]="'0'">
                                                            <b style="color: #ffffff; font-size: 16px">{{
                                                                "evaluation.actionplan.filter.no.completed" | translate
                                                            }}</b></mat-option
                                                        >
                                                        <mat-option [value]="'NA'">{{
                                                            "evaluation.actionplan.filter.na" | translate
                                                        }}</mat-option>
                                                    </mat-select>
                                                } @else {
                                                    <mat-select [(ngModel)]="filterPAForm.status">
                                                        <mat-option [value]="'100'">{{
                                                            "evaluation.actionplan.filter.completed" | translate
                                                        }}</mat-option>
                                                        <mat-option [value]="'50'">{{
                                                            "evaluation.actionplan.filter.progress" | translate
                                                        }}</mat-option>
                                                        <mat-option [value]="'0'">{{
                                                            "evaluation.actionplan.filter.no.completed" | translate
                                                        }}</mat-option>
                                                        <mat-option [value]="'NA'">{{
                                                            "evaluation.actionplan.filter.na" | translate
                                                        }}</mat-option>
                                                    </mat-select>
                                                }
                                            </mat-form-field>
                                            @if (project()?.tandemMode != 1) {
                                                @if (createdByUsers.length) {
                                                    <mat-form-field
                                                        subscriptSizing="dynamic"
                                                        appearance="outline"
                                                        class="w-100-p"
                                                    >
                                                        <mat-label>{{
                                                            "evaluation.actionplan.filter.createdby" | translate
                                                        }}</mat-label>
                                                        <mat-select [(ngModel)]="filterPAForm.createdBy">
                                                            @for (creator of createdByUsers; track creator.id) {
                                                                <mat-option [value]="creator.id">{{
                                                                    creator.name
                                                                }}</mat-option>
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                }
                                            }
                                            <div class="filter-date">
                                                <input
                                                    matInput
                                                    ngxDaterangepickerMd
                                                    [(ngModel)]="filterPAForm.inicio"
                                                    name="inicio"
                                                    placeholder="{{ 'general.start_date' | translate }}"
                                                    [locale]="localeDateRange"
                                                    showClearButton="true"
                                                    alwaysShowCalendars="true"
                                                    keepCalendarOpeningWithRange="true"
                                                    opens="left"
                                                    [id]="'formBackground'"
                                                />
                                            </div>
                                            <div class="filter-date">
                                                <input
                                                    matInput
                                                    ngxDaterangepickerMd
                                                    [(ngModel)]="filterPAForm.fin"
                                                    name="fin"
                                                    placeholder="{{ 'general.end_date' | translate }}"
                                                    [locale]="localeDateRange"
                                                    showClearButton="true"
                                                    alwaysShowCalendars="true"
                                                    keepCalendarOpeningWithRange="true"
                                                    opens="left"
                                                    [id]="'formBackground'"
                                                />
                                            </div>
                                        </div>
                                        <div class="gap-1" fxLayout="row" fxLayoutAlign="center center">
                                            <button mat-raised-button class="btn-feedbalia" (click)="clearFilterPA()">
                                                {{ "general.button.clear" | translate }}
                                            </button>
                                            <button mat-raised-button class="btn-feedbalia" (click)="filterPA()">
                                                {{ "evaluation.filter.btn" | translate }}
                                            </button>
                                        </div>
                                    }
                                }
                                @if (project()?.name === "syrsa") {
                                    <div fxLayout="column" style="height: 20px"></div>
                                }
                            }
                            @if (!nextSelected) {
                                @if (mainPeriod()) {
                                    <div class="container-plan-accion">
                                        @if (actionsPlansLoading()) {
                                            <div fxLayout="row" fxLayoutAlign="center" class="spinner">
                                                <mat-spinner color="accent"></mat-spinner>
                                            </div>
                                        }
                                        @if (urlEntrada === "objetivos") {
                                            <div fxLayout="row" fxLayoutAlign="center" class="spinner">
                                                @if (permisosForzado().w && !isSelfPage && !objetivosRevision()) {
                                                    <button
                                                        mat-raised-button
                                                        color="primary"
                                                        class="w-100-p"
                                                        style="margin: 8px !important"
                                                        (click)="dialogSolicitarObjetivoForzado()"
                                                    >
                                                        {{ "objetivos.forzarobjetivos" | translate }}
                                                    </button>
                                                }
                                                <button
                                                    mat-raised-button
                                                    class="btn-feedbalia w-100-p"
                                                    (click)="openHistorioObjetivos()"
                                                    style="margin: 8px !important"
                                                >
                                                    {{ "evaluation.objetivos.verHistorico" | translate }}
                                                </button>
                                            </div>
                                        }
                                        @if (
                                            permisosForzado().w &&
                                            !isSelfPage &&
                                            !objetivosRevision() &&
                                            person()?.id &&
                                            objId
                                        ) {
                                            @if (pivoteObjetivosForzados) {
                                                <componente-objetivos-forzados
                                                    [idPeriodo]="objId"
                                                    [idPersona]="person()!.id"
                                                ></componente-objetivos-forzados>
                                            } @else {
                                                <componente-objetivos-forzados
                                                    [idPeriodo]="objId"
                                                    [idPersona]="person()!.id"
                                                ></componente-objetivos-forzados>
                                            }
                                        }
                                        @if (actionsPlansLoaded() && !actionsPlansLoading()) {
                                            <div [@slideInRightList]>
                                                @for (itemPA of filteredActionPlans(); track itemPA) {
                                                    <div>
                                                        @if (urlEntrada === "objetivos") {
                                                            <action-plan-blue
                                                                [datos-plan-accion]="itemPA"
                                                                [revisionPeriodEnabled]="false"
                                                                [evpartial-id]="evPartial ? evPartial.id : null"
                                                                [period-id]="null"
                                                                [user]="user()"
                                                                [person]="person()"
                                                                [fullEdit]="canEditObjetivo(itemPA)"
                                                                [fullDuplicar]="
                                                                    objetivosRevision() || mainPeriod()!.isActive
                                                                "
                                                                [editable]="canEditPlanAction(itemPA)"
                                                                [read-only]="
                                                                    person()!.id == user()!.id &&
                                                                    !project()?.autoevaluacionObjetivos
                                                                "
                                                                [startPeriod]="mainPeriod()?.startPeriod"
                                                                [inEvaluation]="false"
                                                                [canBeBlocked]="canBlockPDAs()"
                                                                [permisos]="permisosPDA()"
                                                                (reload)="getActionsPlans()"
                                                                [canForzar]="
                                                                    permisosForzado().w &&
                                                                    !isSelfPage &&
                                                                    !objetivosRevision()
                                                                "
                                                                (onChangeValue)="onChangeElementValue($event)"
                                                            >
                                                            </action-plan-blue>
                                                        } @else {
                                                            <action-plan
                                                                [datos-plan-accion]="itemPA"
                                                                [revisionPeriodEnabled]="
                                                                    paRevisionPeriod ? true : false
                                                                "
                                                                [evpartial-id]="evPartial ? evPartial.id : null"
                                                                [period-id]="null"
                                                                [user]="user()"
                                                                [person]="person()"
                                                                [editable]="canEditPlanAction(itemPA)"
                                                                [read-only]="false"
                                                                [startPeriod]="mainPeriod()?.startPeriod"
                                                                [inEvaluation]="false"
                                                                [canBeBlocked]="canBlockPDAs()"
                                                                [permisos]="permisosPDA()"
                                                                (reload)="getActionsPlans()"
                                                                (onChangeValue)="onChangeElementValue($event)"
                                                            >
                                                            </action-plan>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            } @else {
                                @if (mainPeriod()) {
                                    <div class="container-plan-accion">
                                        @if (nextPDALoading()) {
                                            <div fxLayout="row" fxLayoutAlign="center" class="spinner">
                                                <mat-spinner color="accent"></mat-spinner>
                                            </div>
                                        }
                                        @if (!nextPDALoading()) {
                                            <div [@slideInRightList]>
                                                @for (itemPA of nextPDA(); track itemPA) {
                                                    <div>
                                                        <action-plan-blue
                                                            [datos-plan-accion]="itemPA"
                                                            [revisionPeriodEnabled]="false"
                                                            [evpartial-id]="evPartial ? evPartial.id : null"
                                                            [period-id]="null"
                                                            [user]="user()"
                                                            [person]="person()"
                                                            [editable]="canEditPlanAction(itemPA)"
                                                            [read-only]="false"
                                                            [startPeriod]="mainPeriod()?.startPeriod"
                                                            [inEvaluation]="false"
                                                            [canBeBlocked]="canBlockPDAs()"
                                                            [permisos]="permisosPDA()"
                                                            (reload)="getActionsPlans()"
                                                            (onChangeValue)="onChangeElementValue($event)"
                                                            [fullEdit]="true"
                                                            [fullDuplicar]="false"
                                                            [canForzar]="
                                                                permisosForzado().w &&
                                                                !isSelfPage &&
                                                                !objetivosRevision()
                                                            "
                                                        >
                                                        </action-plan-blue>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            }
                        </div>
                    }
                </div>
                @if (urlEntrada === "objetivos") {
                    <div fxLayout="column" fxFlex="40" class="user-container px-16">
                        @if (colaboradoresObjetivos().length > 0 && isSelfPage) {
                            <div
                                fxLayout="column"
                                class="fuse-card card-border-top card-sied card-planes-accion p-24 gap-1"
                            >
                                <div class="w-100-p contenedor" fxLayout="row">
                                    <div fxLayout="column" class="w-100-p" fxFlex="2 1 0" fxLayoutAlign="start start">
                                        <b style="font-size: 24px; color: var(--feedbalia-color-primary-500)">{{
                                            "evaluation.objetivos.colaboradores" | translate | uppercase
                                        }}</b>
                                    </div>
                                </div>
                                @if (
                                    project()?.enabled_objetivos_departamento && departamentosResponsable().length > 0
                                ) {
                                    <div style="max-height: 450px; overflow-y: auto; padding-right: 8px">
                                        @for (elem of colaboradoresObjetivos(); track elem) {
                                            <div
                                                class="w-100-p contenedor"
                                                fxLayout="row"
                                                style="
                                                    margin-top: 16px;
                                                    border-bottom: 1px solid rgb(242, 242, 242);
                                                    padding: 16px;
                                                "
                                            >
                                                <div
                                                    fxLayout="column"
                                                    class="w-100-p"
                                                    fxFlex="1 1 0"
                                                    fxLayoutAlign="center center"
                                                >
                                                    <img
                                                        class="img-circle"
                                                        [src]="getImagePerson(elem.username)"
                                                        [alt]="elem.name"
                                                    />
                                                </div>
                                                <div
                                                    fxLayout="column"
                                                    class="w-100-p"
                                                    fxFlex="5 1 0"
                                                    fxLayoutAlign="center start"
                                                >
                                                    <span style="font-size: 18px">{{ elem.name }}</span>
                                                </div>
                                                <div
                                                    fxLayout="column"
                                                    class="w-100-p"
                                                    fxFlex="2 1 0"
                                                    fxLayoutAlign="center center"
                                                >
                                                    <button
                                                        mat-raised-button
                                                        class="btn-feedbalia"
                                                        (click)="goToVerObjetivos(elem)"
                                                    >
                                                        {{ "evaluation.objetivos.ver" | translate }}
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                } @else {
                                    <div style="padding-right: 8px">
                                        @for (elem of colaboradoresObjetivos(); track elem) {
                                            <div
                                                class="w-100-p contenedor"
                                                fxLayout="row"
                                                style="
                                                    margin-top: 16px;
                                                    border-bottom: 1px solid rgb(242, 242, 242);
                                                    padding: 16px;
                                                "
                                            >
                                                <div
                                                    fxLayout="column"
                                                    class="w-100-p"
                                                    fxFlex="1 1 0"
                                                    fxLayoutAlign="center center"
                                                >
                                                    <img
                                                        class="img-circle"
                                                        [src]="getImagePerson(elem.username)"
                                                        [alt]="elem.name"
                                                    />
                                                </div>
                                                <div
                                                    fxLayout="column"
                                                    class="w-100-p"
                                                    fxFlex="5 1 0"
                                                    fxLayoutAlign="center start"
                                                >
                                                    <span style="font-size: 18px">{{ elem.name }}</span>
                                                </div>
                                                <div
                                                    fxLayout="column"
                                                    class="w-100-p"
                                                    fxFlex="2 1 0"
                                                    fxLayoutAlign="center center"
                                                >
                                                    <button
                                                        mat-raised-button
                                                        class="btn-feedbalia"
                                                        (click)="goToVerObjetivos(elem)"
                                                    >
                                                        {{ "evaluation.objetivos.ver" | translate }}
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        @if (
                            isResponsableObjetivos() &&
                            isSelfPage &&
                            departamentosResponsable().length > 0 &&
                            project()?.enabled_objetivos_departamento
                        ) {
                            <div
                                fxLayout="column"
                                class="fuse-card card-border-top card-sied card-planes-accion p-24 gap-1"
                                style="margin-top: 16px; max-height: 400px"
                            >
                                <div class="w-100-p contenedor" fxLayout="row">
                                    <div fxLayout="column" class="w-100-p" fxFlex="2 1 0" fxLayoutAlign="start start">
                                        <b style="font-size: 24px; color: var(--feedbalia-color-primary-500)">
                                            OBJETIVOS DE DEPARTAMENTOS
                                        </b>
                                    </div>
                                </div>
                                <div style="max-height: 240px; overflow-y: auto; padding-right: 8px">
                                    @for (departamento of departamentosResponsable(); track departamento) {
                                        <div
                                            class="w-100-p contenedor"
                                            fxLayout="row"
                                            style="
                                                margin-top: 16px;
                                                border-bottom: 1px solid rgb(242, 242, 242);
                                                padding: 16px;
                                            "
                                        >
                                            <div
                                                fxLayout="column"
                                                class="w-100-p"
                                                fxFlex="1 1 0"
                                                fxLayoutAlign="center center"
                                            >
                                                <mat-icon
                                                    style="font-size: 24px; color: var(--feedbalia-color-primary-500)"
                                                    >business</mat-icon
                                                >
                                            </div>
                                            <div
                                                fxLayout="column"
                                                class="w-100-p"
                                                fxFlex="5 1 0"
                                                fxLayoutAlign="center start"
                                            >
                                                <span style="font-size: 18px">{{
                                                    departamento.nombre_departamento
                                                }}</span>
                                            </div>
                                            <div
                                                fxLayout="column"
                                                class="w-100-p"
                                                fxFlex="2 1 0"
                                                fxLayoutAlign="center center"
                                            >
                                                <button
                                                    mat-raised-button
                                                    class="btn-feedbalia"
                                                    (click)="goToObjetivosDepartamento(departamento)"
                                                >
                                                    Mostrar objetivos
                                                </button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}
